export const environment = {
  sURL: 'https://dev-api.sadmincontrol.com/v1/api/',
  bURL: 'https://dev-api.sadmincontrol.com',
  mURL: 'https://dev-market.sadmincontrol.com',
  enableSetRCsubaccount: true,
  enableDashboard: true,
  firstIndexPnl: false,
  riskCalculatorURL: 'https://dev-market.sadmincontrol.com/risk_calculator',
  betTickerURL:'https://dev-betticker',
  betTickerV1URL:'https://dev-betticker-v1',
  pspAdminURL:'https://dev-psp-admin.freedemokit.com',
  kjsport9URL:'https://kjs-back.pkrsrv.com/webadmin-VDX0Xj',
  casinoApiBaseUrl: 'https://dev-casino.sadmincontrol.com',
  shivajiexchangeAdminURL:'https://dev-admin.shivajiexchange.com'

};
